import { render, staticRenderFns } from "./localRemittance.vue?vue&type=template&id=251bf21a"
import script from "./localRemittance.vue?vue&type=script&lang=js"
export * from "./localRemittance.vue?vue&type=script&lang=js"
import style0 from "./localRemittance.vue?vue&type=style&index=0&id=251bf21a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports